module.exports = __webpack_public_path__ + "img/a-jfsc-banner@2x.113cf010.png";